import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@aws-amplify/ui-react/styles.css';
import {Amplify} from 'aws-amplify';

/**
 * Configuracion Autenticación con cognito y endponint de la API en Amplify
 */
Amplify.configure({
  Auth: {
    identityPoolId: 'us-east-1:e0999e52-6eee-4144-80d6-cfdd095867a0', // TODOO - Amazon Cognito Identity Pool ID
    region: 'us-east-1', // REQUIRED - Amazon Cognito Region
    userPoolId: 'us-east-1_qbjbVS37l', // TODOO - Amazon Cognito User Pool ID
    userPoolWebClientId: '6kfvgde7j7bublnj9cueo3a4ls', // TODOO - Amazon Cognito Web Client ID (26-char alphanumeric string)
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
  API: {
    endpoints: [
      {
        name: "PROD",
        endpoint: "https://hbyia10n91.execute-api.us-east-1.amazonaws.com" 
      }
    ]
  }
});



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <App/>
  </React.StrictMode>,
);

